// @noflow
import { flow } from 'lodash/fp';

export const toFarenheit = celsius => Math.round(celsius * 1.8 + 32);

const farnenheitToCelsius = farenheit => (farenheit - 32) / 1.8;
const roundToHalfDegree = temperature => (Math.round(temperature * 2) / 2).toFixed(1);
const convertToNumber = Number;

export const toCelsius = flow(farnenheitToCelsius, roundToHalfDegree, convertToNumber);



// WEBPACK FOOTER //
// ./src/core/utils/temperature.js